module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DEATH MARCH THROUGH RUSSIA")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("My Journey from Soldier to Prisoner of War")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Klaus Willmann")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("(As told to him by Lothar Herrmann)")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword by")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Roger Moorhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Translated by")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Eva Burke")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c0d47ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0